<template>
	<div>
		<p class="lead">{{ formMessage }}</p>
		<div v-if="isSubmitted">
			<slot></slot>
		</div>
		<el-form id="contactForm" v-show="!isSubmitted" label-position="top" :model="contactForm" :rules="rules" ref="contactForm">
			<el-form-item label="Name" prop="name">
				<el-input placeholder="Your name" v-model="contactForm.name"></el-input>
			</el-form-item>

			<el-form-item label="Email" prop="email">
				<el-input placeholder="you@domain.com" v-model="contactForm.email"></el-input>
			</el-form-item>

			<el-form-item label="Phone" prop="phone">
				<el-input placeholder="Your phone number" v-model="contactForm.phone"></el-input>
			</el-form-item>

			<el-form-item label="Subject" prop="subject">
				<el-select class="d-block" v-model="contactForm.subject" placeholder="Select...">
					<el-option
						v-for="item in subjects"
						:key="item.value"
						:label="item.label"
						:value="item.value">
					</el-option>
				</el-select>
			</el-form-item>

			<el-form-item label="Message" prop="message">
				<el-input
					type="textarea"
					:autosize="{ minRows: 3, maxRows: 5}"
					:rows="3"
					placeholder="Leave a message"
					v-model="contactForm.message">
				</el-input>
			</el-form-item>

			<el-button type="primary" @click="onSubmit('contactForm')">Send</el-button>
		</el-form>

	</div>
</template>

<script>
	let Http = require('../mixins/http');

	export default {
		mixins: [Http],
		props: {
			user: Object,
			subjects: Array,
			endpoint: String,
			message: String
		},

		data() {
			return {
				isSubmitted: false,
				formMessage: this.message,
				contactForm: {
					name: this.user.name,
					email: this.user.email,
					phone: '',
					subject: '',
					message: ''
				},
				rules: {
					name: [
						{required: true, message: 'Please add your name', trigger: 'blur'},
					],
					email: [
						{type: 'email', required: true, message: 'Please add your email', trigger: 'blur'},
					],
					phone: [
						{min: 10, message: 'Please enter a valid phone number', trigger: 'blur'}
					],
					subject: [
						{required: true, message: 'Please select a subject', trigger: 'blur'},
					],
					message: [
						{required: true, message: 'Please leave a message', trigger: 'blur'},
					],
				}
			}
		},

		methods: {
			onSubmit(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.sendRequest(this.endpoint, 'post', this.finish, this.contactForm);
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},

			finish(data, message) {
				this.isSubmitted = true;
				this.formMessage = message.content;
			}
		}
	}
</script>
